import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AvisoVersion } from './pwa/AvisoVersion';
import './styles/index.css';
import { cargarTemaRemoto } from './features/branding/tema';

void cargarTemaRemoto();

const contenedor = document.getElementById('raiz');
if (!contenedor) {
  throw new Error('Falta el contenedor #raiz en index.html');
}

createRoot(contenedor).render(
  <StrictMode>
    <AvisoVersion />
    <App />
  </StrictMode>,
);
